import Icon from "../Icon";
import { useDispatch, useSelector } from "react-redux";
import * as actionCreators from "../../store/actionCreators";
import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";

function UserProfileMenu() {
  const dispatch = useDispatch();
  const state = useSelector((state) => state.auth);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const logout = () => {
    dispatch(actionCreators.logout(state.token, setLoading, navigate));
  };
  return (
    <div className="p-4 relative z-50 min-w-[17rem]">
      <div className="w-8 h-8 flex items-center ml-auto cursor-pointer hover:bg-slate-300 justify-center shadow rounded-lg">
        <Icon name="edit" className="w-4 h-4 fill-none" />
      </div>
      {/* USER NAME */}
      <div className="flex gap-2 items-center mt-[-1rem]  mb-6">
        <img
          src={
            "https://cdn.pixabay.com/photo/2014/07/09/10/04/man-388104_960_720.jpg"
          }
          className="w-[4rem] h-[4rem] block rounded-full object-cover"
          alt="profile"
        />

        <div>
          <h1 className="font-[700] capitalize text-lg text-greySecondary">
            {state.user?.firstname + " " + state.user?.lastname}
          </h1>
          <h2 className="font-SpaceGrotesk capitalize font-[600] text-darkPrimary text-lg">
            {state.user?.address}
          </h2>
        </div>
      </div>
      <div className="divide-x-2"></div>
      <div className="">
        <h2 className="text-greySecondary text-lg font-[600]">Phone</h2>
        <h3 className="font-SpaceGrotesk text-lg">{state.user?.phone}</h3>
      </div>
      <div className="mb-6">
        <h2 className="text-greySecondary text-lg font-[600]">Email</h2>
        <h3 className="font-SpaceGrotesk text-lg">{state.user?.email}</h3>
      </div>

      {/* LIST */}
      <div className="flex flex-col gap-1">
        <button className="flex hover:bg-slate-200 rounded-lg p-1 px-2 gap-2 items-center">
          <Icon name="favourite" className="w-4 h-4" />
          <h2>Favourite</h2>
          <Icon name="arrowDown" className="w-4 h-3 ml-auto" />
        </button>
        <button className="flex hover:bg-slate-200 rounded-lg p-1 px-2 gap-2 items-center">
          <Icon name="bell" className="w-4 h-4" />
          <h2>Notifications</h2>
        </button>
        <Link to="usersetting">
          <button className="flex hover:bg-slate-200 rounded-lg p-1 px-2 gap-2 items-center">
            <Icon name="settings" className="w-4 h-4" />
            <h2>Settings</h2>
          </button>
        </Link>
        <Link to="orderdetails">
          <button className="flex hover:bg-slate-200 rounded-lg p-1 px-2 gap-2 items-center">
            <Icon name="settings" className="w-4 h-4" />
            <h2>Order Details</h2>
          </button>
        </Link>

        <button
          onClick={logout}
          disabled={loading}
          className="flex disabled:cursor-wait hover:bg-slate-200 rounded-lg p-1 px-2 gap-2 items-center"
        >
          <Icon
            name="logout"
            className={`w-4 h-4 ${loading ? "fill-greyPrimary" : null}`}
          />
          {loading ? (
            <p className="text-greyPrimary">Logging out...</p>
          ) : (
            "Logout"
          )}
        </button>
      </div>
    </div>
  );
}

export default UserProfileMenu;
